import l from "color";
import a from "color-string";
const C = {
  groupColor01: "#ff587e",
  groupColor02: "#ca58c7",
  groupColor03: "#dd4600",
  groupColor04: "#d77a0a",
  groupColor05: "#128297",
  groupColor06: "#008648",
  groupColor07: "#1e43a6",
  groupColor08: "#4570e0",
  groupColor09: "#6825d1",
  groupColor10: "#8852dc",
  groupColorUngrouped: "#6a6c75"
}, F = {
  green: "green",
  teal: "teal",
  blue: "blue",
  purple: "purple",
  magenta: "magenta",
  yellow: "yellow",
  orange: "orange",
  red: "red",
  gray: "gray"
};
function b(o) {
  return o.includes("#") ? o.toUpperCase() : `#${o.toUpperCase()}`;
}
function A(o) {
  return l(o).alpha();
}
function d({ r: o, g: r, b: e, alpha: t }) {
  return `rgba(${[o, r, e, t].join(",")})`;
}
function i({ r: o, g: r, b: e, alpha: t }) {
  if (t < 1) {
    const u = a.to.hex([Math.round(o), Math.round(r), Math.round(e), t]);
    return {
      hex: u,
      hex8: u
    };
  }
  const n = a.to.hex([Math.round(o), Math.round(r), Math.round(e)]);
  return {
    hex: n,
    hex8: `${n}FF`
  };
}
function M(o) {
  return typeof o == "string" && /(^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$|^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$)/.test(o);
}
function x(o) {
  let r;
  o && o.hsl ? r = l(o.hsl) : o && o.hex && o.hex.length > 0 ? r = l(o.hex) : r = l(o), o.alpha && (r = r.alpha(o.alpha));
  const e = r.hsl().object(), t = r.hsv().object(), { r: n, g: u, b: g, alpha: s } = r.rgb().object(), { hex: p, hex8: c } = i({ r: n, g: u, b: g, alpha: s });
  return {
    r: Math.round(n),
    g: Math.round(u),
    b: Math.round(g),
    alpha: isNaN(s) ? 1 : s,
    hex: p,
    hex8: c,
    hsv: t,
    hsl: e
  };
}
function m(o) {
  o.startsWith("#") && (o = o.slice(1, o.length));
  const r = parseInt(o.substr(0, 2), 16), e = parseInt(o.substr(2, 2), 16), t = parseInt(o.substr(4, 2), 16);
  return (r * 299 + e * 587 + t * 114) / 1e3 >= 128 ? "#2A2C35" : "#FFFFFF";
}
export {
  C as PRODUCT_AREA_COLORS,
  F as STATUS_COLOR_MAP,
  A as getAlpha,
  x as getColor,
  m as getContrastingColor,
  M as isValidHex,
  b as normalizeHex,
  i as toHexString,
  d as toRgbString
};
//# sourceMappingURL=color.js.map
